import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class CategoryList extends React.Component {
  state = {
    categoryList: [],
    isModalOpen: false,
    pushId: '',
    pushTitle: '',
    pushMessage: '',
  }

  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            categoryList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive) => {
    var data = {
      cruise_master_id: id,
      is_active: isActive,
    }

    await axios
      .put(Constant.getAPI() + '/admin/update-cruise-master-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: 'Updated !',
            icon: 'success',
            text: 'Status has been Changed',
            confirmButtonText: 'Ok',
          }).then(() => {
            window.location.reload()
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  // onPushClick = (id, metaData) => {
  //   this.setState({
  //     isModalOpen: true,
  //     pushTitle: metaData.rowData[1].slice(0, 22),
  //     pushId: id,
  //   })
  // }

  onModalClose = () => {
    this.setState({
      pushId: '',
      pushTitle: '',
      pushMessage: '',
      isModalOpen: false,
    })
  }

  sendPush = () => {
    this.setState({ isData: true })

    if (!this.state.pushTitle || !this.state.pushMessage) {
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'All fields are required...',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })

      this.setState({ isData: false })
      return
    }

    const data = {
      pushTitle: this.state.pushTitle,
      message: this.state.pushMessage,
      type: 'C',
      typeId: this.state.pushId,
    }

    axios
      .post(Constant.getAPI() + '/admin/send-push', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Notification sent Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.onModalClose()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    const columns = [
      {
        name: 'cruise_cat_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_cat_img) => {
            return (
              <div>
                {cruise_cat_img !== null ? (
                  <div>
                    {cruise_cat_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_cat_img !== undefined && cruise_cat_img !== null && cruise_cat_img !== {}
                              ? Constant.getImage() + cruise_cat_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          cruise_cat_img !== undefined && cruise_cat_img !== null && cruise_cat_img !== {}
                            ? Constant.getImage() + cruise_cat_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_cat_img !== undefined && cruise_cat_img !== null && cruise_cat_img !== {}
                        ? Constant.getImage() + cruise_cat_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'cruise_cat_en',
        label: 'Category Name: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_cat_ar',
        label: 'Category Name:Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'upto_s',
        label: 'Upto',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'category_type',
        label: 'Category Type',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'order',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'is_active' + tableMeta.rowData[7]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[7], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={'/category/add/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <span
                  onClick={this.onPushClick.bind(this, id, tableMeta)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Send Push"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-notification text-warning"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Category Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <Modal
          open={this.state.isModalOpen}
          onClose={this.onModalClose}
          center
        >
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Title</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="pushTitle"
                      id="title"
                      placeholder="Title"
                      onChange={this.handleChange}
                      value={this.state.pushTitle}
                      maxLength="22"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Message</label>
                  <div className="col-sm-9">
                    <textarea
                      type="text"
                      className="form-control"
                      name="pushMessage"
                      id="message"
                      placeholder="Message"
                      onChange={this.handleChange}
                      value={this.state.pushMessage}
                      rows="4"
                      cols="50"
                      maxLength="53"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-right col-6 offset-6">
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Sending...!
                  </button>
                ) : (
                  <button
                    onClick={this.sendPush}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Send
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Category Master</h4>
                    </div>
                  </div>
                  <Link
                    to="/category/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Category
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Category Master</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Category Master'}
                          className="table-responsive"
                          data={this.state.categoryList}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CategoryList
